<template>
    <div class="container">
        <v-layout mb-6>
            <v-flex shrink d-flex justify-start align-center style="color: #000000;font-weight: bold;font-size: 24px;">
                <span style="margin-left: 25px;margin-right: 25px;">ประเภทโครงการ</span>
                <v-select hide-details clearable background-color="#ffffff" solo flat dense label="Initial"
                    :items="projectType" item-text="name" item-value="value" @change="project_type"
                    v-model="searchData.projectType" />
                <span style="margin-left: 25px;margin-right: 25px;">ปี</span>
                <v-select hide-details clearable background-color="#ffffff" solo flat dense :items="projectYear"
                    item-text="name" item-value="value" v-model="searchData.projectYear" />
                <v-btn color="#3e7662" dark style="margin-left: 15px;" @click="search(searchData.projectType)">
                    <span class="font-weight-bold">ค้นหา</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <div v-if="searchData.projectType === 'fullboard'" style="width: 100%;">
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(62, 118, 98);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 3px;">เอกสารครบ (วันที่เลขรับออก) ถึง
                        วันที่เข้าประชุม (Fullborad)
                    </div>
                </div>
            </div>
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(169, 169, 169);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-right: 48px; margin-left: 3px;">
                        วันที่เข้าประชุม (Fullborad)
                        ถึง วันที่แจ้งผลพิจารณา</div>
                </div>
            </div>
        </div>
        <div v-else-if="searchData.projectType === 'expedited'" style="width: 100%;">
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(62, 118, 98);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 3px;">เอกสารครบ (วันที่เลขรับออก) ถึง
                        วันที่เข้าประชุม (Fullborad)
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="searchData.projectType === 'exemption'" style="width: 100%;">
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(62, 118, 98);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 3px;">เอกสารครบ (วันที่เลขรับออก) ถึง
                        วันที่เข้าประชุม (Fullborad)
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="searchData.projectType === 'amendment' || searchData.projectType === 'sae' || searchData.projectType === 'deviation' || searchData.projectType === 'progress' || searchData.projectType === 'final'"
            style="width: 100%;">
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(62, 118, 98);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 3px;">เอกสารครบ (วันที่เลขรับออก) ถึง
                        วันที่เข้าประชุมย่อย
                    </div>
                </div>
            </div>
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(169, 169, 169);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-right: 48px; margin-left: 3px;">
                        เอกสารครบ (วันที่เลขรับออก)
                        ถึง วันที่แจ้งผลพิจารณา</div>
                </div>
            </div>
        </div>
        <div v-else style="width: 100%;">
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(62, 118, 98);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-left: 3px;">เอกสารครบ (วันที่เลขรับออก) ถึง
                        วันที่เข้าประชุม (Fullborad)
                    </div>
                </div>
            </div>
            <div class="flex-container">
                <div class="grid-2 callout" style="background-color: rgb(169, 169, 169);"></div>
                <div>
                    <div style="font-size: 14px;font-weight: bold;margin-right: 48px; margin-left: 3px;">
                        วันที่เข้าประชุม (Fullborad)
                        ถึง วันที่แจ้งผลพิจารณา</div>
                </div>
            </div>
        </div>
        <line-chart v-if="loaded" :chartdata="chartdata" :options="options" />
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import LineChart from './Chart.vue'
import axios from 'axios'
import { domain } from '../../services/Constants'

export default {
    components: { LineChart, Loading },
    data() {
        return {
            loaded: false,
            chartdata: {
                labels: [],
                datasets: [{
                    label: '',
                    data: [],
                    backgroundColor: [],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                    ],
                },
                {
                    label: '',
                    data: [],
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                    ],
                }],

            },
            options: {
                legend: {
                    display: false,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)'
                    }
                },
                animation: {
                    duration: 1000,
                },
                labels: false,
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                }
            },
            searchData: {
                projectType: "fullboard",
                projectYear: new Date().getFullYear()
            },
            projectType: [
                { id: "1", value: "fullboard", name: "Initial" },
                { id: "2", value: "expedited", name: "Expedited" },
                { id: "3", value: "exemption", name: "Exemption" },
                { id: "4", value: "amendment", name: "Amendment" },
                { id: "5", value: "sae", name: "SAE" },
                { id: "6", value: "deviation", name: "Deviation" },
                { id: "7", value: "progress", name: "Progress" },
                { id: "8", value: "final", name: "Final" },
            ],
            projectYear: [],
            emptyText: 'No data',
        }
    },
    async mounted() {
        await this.generateYearOptions();
        await this.search();
    },
    methods: {
        generateYearOptions() {
            const currentYear = new Date().getFullYear()
            for (let i = 0; i < 5; i++) {
                const year = currentYear - i
                const buddhistYear = year + 543
                this.projectYear.push({ value: year, name: buddhistYear })
            }
        },
        async search(name) {
            this.isLoading = true;
            this.loaded = false
            this.chartdata.labels = [];
            this.chartdata.datasets[0].data = [];
            this.chartdata.datasets[1].data = [];
            this.chartdata.datasets[0].backgroundColor = [];
            this.chartdata.datasets[1].backgroundColor = [];
            try {
                const response = await axios.get(domain + 'api/get-research-by-code?projectType=' + this.searchData.projectType + '&projectYear=' + this.searchData.projectYear);
                if (name === 'fullboard') {
                    for (let month in response.data.data1) {
                        this.chartdata.labels.push(month);
                        this.chartdata.datasets[0].data.push(response.data.data1[month]);
                        this.chartdata.datasets[0].backgroundColor.push('rgb(169, 169, 169)');
                    }
                    for (let month in response.data.data2) {
                        this.chartdata.datasets[1].data.push(response.data.data2[month]);
                        this.chartdata.datasets[1].backgroundColor.push('rgb(62, 118, 98)');
                    }
                }
                else if (name === 'expedited') {
                    for (let month in response.data.data1) {
                        this.chartdata.labels.push(month);
                    }
                    for (let month in response.data.data2) {
                        this.chartdata.datasets[1].data.push(response.data.data2[month]);
                        this.chartdata.datasets[1].backgroundColor.push('rgb(62, 118, 98)');
                    }
                } else if (name == 'exemption') {
                    for (let month in response.data.data1) {
                        this.chartdata.labels.push(month);
                    }
                    for (let month in response.data.data2) {
                        this.chartdata.datasets[1].data.push(response.data.data2[month]);
                        this.chartdata.datasets[1].backgroundColor.push('rgb(62, 118, 98)');
                    }
                } else if (name === 'amendment' || name === 'sae' || name === 'deviation' || name === 'progress' || name === 'final') {
                    for (let month in response.data.data1) {
                        this.chartdata.labels.push(month);
                    }
                    for (let month in response.data.data2) {
                        this.chartdata.datasets[1].data.push(response.data.data2[month]);
                        this.chartdata.datasets[1].backgroundColor.push('rgb(62, 118, 98)');
                    }
                } else {
                    for (let month in response.data.data1) {
                        this.chartdata.labels.push(month);
                        this.chartdata.datasets[0].data.push(response.data.data1[month]);
                        this.chartdata.datasets[0].backgroundColor.push('rgb(169, 169, 169)');
                    }
                    for (let month in response.data.data2) {
                        this.chartdata.datasets[1].data.push(response.data.data2[month]);
                        this.chartdata.datasets[1].backgroundColor.push('rgb(62, 118, 98)');
                    }
                }
                this.loaded = true
                this.isLoading = false;
            } catch (e) {
                console.error(e)
                this.isLoading = false;
            }
        },
    }

}
</script>
<style>
.grid-1 {
    width: 2vh;
    height: 5vh;
}

.grid-2 {
    width: 2.5vh;
    height: 2.5vh;
}

.callout {
    margin: 0;
    background-color: silver;
}

.flex-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
}
</style>
